import { createSelector } from '@reduxjs/toolkit';
import { AdminState } from 'reduxStore/appStore';

import { WebLinkDistributionState } from './initialState';

export const selectWebLinkDomain = (state: AdminState) =>
  state.webLink as WebLinkDistributionState.Domain;

export const selectWebLinkDistributionResource = createSelector(
  selectWebLinkDomain,
  (domain: WebLinkDistributionState.Domain) => domain.distributionResource,
);
